import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const TournamentResults = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const recentResults = [
    {
      id: 1,
      tournament: "Valorant Winter Cup 2024",
      date: "2024-01-20",
      winner: "Team Phoenix",
      prize: "$30,000",
      participants: 64,
      game: "Valorant"
    },
    {
      id: 2, 
      tournament: "CS2 New Year Championship",
      date: "2024-01-15",
      winner: "Revenant Esports",
      prize: "$45,000", 
      participants: 32,
      game: "Counter-Strike 2"
    },
    {
      id: 3,
      tournament: "League of Legends Holiday Tournament",
      date: "2024-01-10",
      winner: "Dragon Slayers",
      prize: "$20,000",
      participants: 48,
      game: "League of Legends"
    }
  ];

  const topPlayers = [
    {
      rank: 1,
      player: "ShadowHunter",
      points: 2450,
      tournaments: 8,
      wins: 6,
      game: "Valorant"
    },
    {
      rank: 2,
      player: "CyberNinja", 
      points: 2380,
      tournaments: 7,
      wins: 5,
      game: "CS2"
    },
    {
      rank: 3,
      player: "EliteGamer",
      points: 2290,
      tournaments: 9,
      wins: 5,
      game: "League of Legends"
    },
    {
      rank: 4,
      player: "ProShooter",
      points: 2180,
      tournaments: 6,
      wins: 4,
      game: "Valorant"
    },
    {
      rank: 5,
      player: "GameMaster", 
      points: 2150,
      tournaments: 8,
      wins: 4,
      game: "CS2"
    }
  ];

  const handleViewLeaderboard = () => {
    navigate('/leaderboard');
  };

  return (
    <section className="py-16 bg-gray-800">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Tournament Results & Leaderboards</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Check out recent tournament winners and see where you rank on our global leaderboards
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Recent Results */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
              <i className="ri-trophy-line text-yellow-400 mr-3"></i>
              Recent Winners
            </h3>
            <div className="space-y-4">
              {recentResults.map((result) => (
                <div key={result.id} className="bg-gray-900 rounded-lg p-6 border border-gray-700">
                  <div className="flex items-center justify-between mb-3">
                    <h4 className="text-lg font-semibold text-white">{result.tournament}</h4>
                    <span className="text-gray-400 text-sm">{result.date}</span>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-purple-400 font-semibold text-lg">{result.winner}</p>
                      <p className="text-gray-400 text-sm">{result.game} • {result.participants} teams</p>
                    </div>
                    <div className="text-right">
                      <p className="text-green-400 font-bold text-xl">{result.prize}</p>
                      <p className="text-gray-400 text-sm">Prize Won</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Leaderboard */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
              <i className="ri-medal-line text-purple-400 mr-3"></i>
              Top Players
            </h3>
            <div className="bg-gray-900 rounded-lg border border-gray-700 overflow-hidden">
              <div className="p-4 bg-gray-800 border-b border-gray-700">
                <div className="grid grid-cols-5 gap-4 text-sm font-semibold text-gray-400">
                  <span>Rank</span>
                  <span>Player</span>
                  <span>Points</span>
                  <span>Tournaments</span>
                  <span>Wins</span>
                </div>
              </div>
              
              <div className="divide-y divide-gray-700">
                {topPlayers.map((player) => (
                  <div key={player.rank} className="p-4 hover:bg-gray-800 transition-colors">
                    <div className="grid grid-cols-5 gap-4 items-center">
                      <div className="flex items-center">
                        <span className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                          player.rank === 1 ? 'bg-yellow-500 text-black' :
                          player.rank === 2 ? 'bg-gray-400 text-black' :
                          player.rank === 3 ? 'bg-orange-500 text-white' :
                          'bg-gray-700 text-white'
                        }`}>
                          {player.rank}
                        </span>
                      </div>
                      
                      <div>
                        <p className="text-white font-semibold">{player.player}</p>
                        <p className="text-gray-400 text-xs">{player.game}</p>
                      </div>
                      
                      <span className="text-purple-400 font-bold">{player.points.toLocaleString()}</span>
                      <span className="text-gray-300">{player.tournaments}</span>
                      <span className="text-green-400 font-semibold">{player.wins}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="mt-6 text-center">
              <button 
                onClick={handleViewLeaderboard}
                className="bg-transparent border border-purple-400 text-purple-400 hover:bg-purple-400 hover:text-white px-6 py-2 rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-list-ordered mr-2"></i>
                View Full Leaderboard
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TournamentResults;
